import { Component, OnInit, ViewChild } from '@angular/core';
import { IonSlides, ModalController, NavController } from '@ionic/angular';
import { UiService } from 'src/app/admin/service/ui.service';
import { AppComponent } from 'src/app/app.component';
import { EmergenciesComponent } from 'src/app/generales/components/emergencies/emergencies.component';
import { OfertComponent } from 'src/app/generales/components/ofert/ofert.component';
import { PublicityService } from 'src/app/services/publicity.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.scss'],
})
export class HomePage implements OnInit{
  @ViewChild('slidesHome', { static: true }) slidesHome: IonSlides;
  imgs = []
  url: string = environment.url;
  buttons = [
    {
      img: './assets/img/imagenesGenerales/Promociones.png',
      text: 'WORDS.PROMOCIONES',
      type: 'promo'
    },
    {
      img: './assets/img/imagenesGenerales/Ofertas-de-trabajo.png',
      text: 'SENTENSES.OFERTAS_DE_TRABAJO',
      type: 'oferts'
    },
    {
      img: './assets/img/imagenesGenerales/Emergencias.png',
      text: 'WORDS.EMERGENCIAS',
      type: 'emergencies'
    }
  ]

  slideOpt = {
    loop: true,
    speed: 400,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
  }

  constructor(
    private modalController: ModalController,
    private navCtrl: NavController,
    public installPwa: AppComponent,
    private uiSv: UiService,
    private publicitySv: PublicityService
  ) {}
  
  async ngOnInit() {
    const sliderHome: any[] = await this.publicitySv.getPublicity(1, 1);
    sliderHome.forEach(item => {
      this.imgs.push({url: `${this.url}/file/publicity/${item.file}`, action: item.action});
    });
    console.log(sliderHome);
    
    await this.slidesHome.startAutoplay();
  }

  async showOpts(type){
    if(type === 'emergencies'){
      const modalEmergencies = await this.modalController.create({
        component: EmergenciesComponent,
        cssClass: 'emergenciesComponent'
      })
  
      await modalEmergencies.present();
    }else if(type === 'promo'){
      this.navCtrl.navigateRoot('/market-place/search/1', { queryParams: { setPrice: 1 } });
    }else if(type === 'oferts'){
      await this.uiSv.createModal(OfertComponent, undefined, 'emergenciesComponent')
    }
  }

  goTo(url){
    this.navCtrl.navigateForward(url)
  }

  openUrl(url){
    if(url) window.open(url, '_blank');
  }
}
